export function formatLineNumber(lineNumber: number) {
  return lineNumber.toString().padStart(2, '0');
}
